import type { CSSProperties } from 'react';

import type { UseBreakpointProps } from '@hivebrite/design-system/theme/src/hooks/breakpoint/types';

import type { HeadlineItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/headlineItemAttributes';

interface GetWrapperHeadlineStyleArgs {
  attributes: HeadlineItemAttributes;
  breakpoint: UseBreakpointProps;
}

export const getWrapperHeadlineStyle = ({
  attributes,
  breakpoint,
}: GetWrapperHeadlineStyleArgs): CSSProperties => ({
  fontFamily: attributes.textFontFamily,
  fontSize: `${attributes.headlineFontSize[breakpoint]}px`,
  lineHeight: `${attributes.headlineLineHeight[breakpoint]}px`,
  margin: '0',
  padding: attributes.containerPadding,
  whiteSpace: 'break-spaces',
  wordBreak: 'break-word',
  width: '100%',
});
